module.exports = __webpack_public_path__ + "static/img/bokeh-photography-of-person-holding-turned-on-iphone-1440727.6c560740.jpg";